export const messageConstants = {
  MSG_GETALL_REQUEST: 'MSG_GETALL_REQUEST',
  MSG_GETALL_SUCCESS: 'MSG_GETALL_SUCCESS',

  MSG_SEND_REQUEST: 'MSG_SEND_REQUEST',
  MSG_SEND_SUCCESS: 'MSG_SEND_SUCCESS',

  MSG_ADD_MESSAGE: 'MSG_ADD_MESSAGE',
  MSG_SET_MESSAGE: 'MSG_SET_MESSAGE',
  MSG_INIT_STATE: 'MSG_INIT_STATE',

}